import axios from 'axios';
import authHeader from './auth-header';

const API_URL = process.env.REACT_APP_API_URL_BASE+'api/test/';
const ADMIN_API_URL = process.env.REACT_APP_API_URL_BASE+'api/admin/';

class UserService { 
  getPublicContent() {
    return axios.get(API_URL + 'all'); 
  }

  getUserBoard() {
    return axios.get(API_URL + 'user', { headers: authHeader() });
  }

  getAdminUsers() {
    return axios.get(ADMIN_API_URL + 'users', { headers: authHeader() }).then(res => res.data);
  }
}

export default new UserService();
